import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#0F1115]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Link
          to="/"
          data-testid="legal-back"
          className="inline-flex items-center gap-2 text-sm text-[#94A3B8] hover:text-white transition-colors mb-8"
        >
          <ArrowLeft size={16} /> Back to Christovibes
        </Link>
        <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-semibold mb-3">{eyebrow}</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white tracking-tight mb-3" style={{ fontFamily: 'Clash Display, sans-serif' }}>
          {title}
        </h1>
        <p className="text-sm text-[#64748B] mb-10">Last updated: {updated}</p>
        <div className="prose prose-invert max-w-none text-[#CBD5E1] leading-relaxed space-y-6 text-[15px]">
          {children}
        </div>
        <div className="mt-16 border-t border-white/5 pt-8 flex flex-wrap gap-4 text-sm">
          <Link to="/privacy" className="text-[#94A3B8] hover:text-[#D4AF37]">Privacy Policy</Link>
          <span className="text-[#334155]">·</span>
          <Link to="/terms" className="text-[#94A3B8] hover:text-[#D4AF37]">Terms of Service</Link>
          <span className="text-[#334155]">·</span>
          <Link to="/cookies" className="text-[#94A3B8] hover:text-[#D4AF37]">Cookie Policy</Link>
          <span className="text-[#334155]">·</span>
          <a href="mailto:hello@christovibes.com" className="text-[#94A3B8] hover:text-[#D4AF37]">Contact us</a>
        </div>
      </div>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="text-xl sm:text-2xl font-semibold text-white mt-10 mb-3" style={{ fontFamily: 'Clash Display, sans-serif' }}>{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="text-base font-semibold text-white mt-6 mb-2">{children}</h3>;
}
export function P({ children }) {
  return <p className="text-[#CBD5E1]">{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-5 space-y-1.5 text-[#CBD5E1] marker:text-[#D4AF37]/50">{children}</ul>;
}
